export const createToastErrorHandler = (Vue) => {
  return (error) => {
    Vue.toasted.error(
      `Ett fel uppstod: ${error.title}`, 
      {
        action : {
          text : "Stäng",
          onClick : (e, toast) => {
            toast.goAway(0);
          }
        },
      });
  };
};
